// NOTE: 2026-05-05: These curried validator functions are going to be part of the wider work being in CARE-2370 epic. Implemented for easier-to-use functions in CARE-2284
import i18next from 'i18next';

export const required = () => (value) => {
    const isEmpty = Array.isArray(value) ? value.length === 0 : !value;
    return isEmpty ? i18next.t('This field is required') : null;
};

export const maxLength = (n) => (value) => (value && value.length > n ? i18next.t('Maximum %(n)s characters allowed', { n }) : null);

export const minLength = (n) => (value) => (value && value.length < n ? i18next.t('Minimum %(n)s characters required', { n }) : null);

export const email =
    () =>
    (value = '') => {
        const emailValidator =
            /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;

        return value && !emailValidator.test(value) ? i18next.t('Enter a valid email address') : null;
    };

export const noSpecialCharacters = () => (str) => {
    if (!str || typeof str !== 'string') return null;

    const regex = /[!@#$%^&*()_+\-=[\]{};:"'\\|,.<>/?]/;
    const containsSpecialChars = regex.test(str);

    if (containsSpecialChars) return i18next.t('Contains special characters');
    return null;
};

export const positiveInteger = () => (value) => {
    const parsed = parseInt(value, 10);

    const isIntegerPositive = Number.isInteger(parsed) && parsed > 0;

    if (isIntegerPositive) return null;
    return i18next.t('Enter a number greater than 0');
};

export const dateNotInPast = () => (date) => {
    if (!date) return null;

    const selected = new Date(date);
    selected.setHours(0, 0, 0, 0);

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const isDateProvidedInPast = selected.getTime() < today.getTime();

    if (isDateProvidedInPast) return i18next.t('Please choose a date in the future');
    return null;
};
